export default __webpack_public_path__ + "static/bratz-banner-b13ac3e91826afa1bbe022df7325f095.webp";